import { MutableRefObject, useEffect, useMemo, useRef, useState } from "react";
import { Background, CampaignImg, CampaignImgBg, CampaignImgDiv, GiftcardWidth, GiftcardWrapper, Wrapper, WrapperWhenBanner } from "./FormEnrollmentNew.styles";
import OccupationStep from "./Steps/OccupationStep";
import ProductStep from "./Steps/ProductStep";
import CircumstanceStep from "./Steps/CircumstanceStep";
import InformationStep from "./Steps/InformationStep";
import YourConsentStep from "./Steps/YourConsentStep";
import PaymentStep from "./Steps/PaymentStep";
import ThankYouStep from "./Steps/ThankYouStep";
import { useStore } from "../../store/store";
import ContactMeReciept from "./Steps/ContactMeReciept";
import { fetchTranslations, fetchUnemploymentInsuranceOptions, fetchUnionOptions } from "../../utils/api";
import { useWindowResize } from "../../hooks/useWindowResize";
import axios from "axios";
import { AccordionRoutesEnum } from "../../types/AccordionRoutes";
import GiftCardPopup from "../../components/GiftCardPopup";
import Analytics from "../../utils/analytics";
import { TrackingFlowTypeEnum } from "../../types/TrackingFlowTypeEnum";
import ProductStepV2 from "./Steps/ProductStepV2";
import Basket from "./components/Basket";
import HelpForm from "./components/HelpForm";
import { PayloadTypeEnum } from "../../types/PayloadTypeEnum";

export enum VisibleLayoutEnum {
  Accordion = "Accordion",
  ThankYou = "ThankYou",
  CallMeReciept = "CallMeReciept",
}

export default function FormEnrollmentNew() {
  const payload = useStore.usePayload();
  const translations = useStore.useTranslations();
  const switchLayout = useStore.useSwitchLayout();
  const accordionRoute = useStore.useAccordionRoute();
  const showTimerPopupOI = useStore.useShowTimerPopupOI();
  const showExitIntentPopupOI = useStore.useShowExitIntentPopupOI();
  const completedAccordionRoute = useStore.useAccordionRouteCompletedArray();
  const setCompletedAccordionRoute = useStore.useSetCompletedAccordionRoute();
  const setAccordionRoute = useStore.useSetAccordionRoute();
  const setTranslations = useStore.useSetTranslation();
  const setOfferEnabled = useStore.useSetOfferEnabled();
  const setDiscountCodesEnabled = useStore.useSetDiscountCodesEnabled();
  const setPayload = useStore.useSetPayload();
  const setTestUrl = useStore.useSetTestUrl();
  const setUnemploymentInsuranceOptions = useStore.useSetUnimploymentInsuranceOptions();
  const setUnionOptions = useStore.useSetUnionOptions();
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [campaignImgUrl, setCampaignImgUrl] = useState("");
  const [campaignMobileImgUrl, setCampaignMobileImgUrl] = useState("");
  const [source, setSource] = useState<string>();
  const [hasShownTimerPopup, setHasShownTimerPopup] = useState(false);
  const [hasShownExitIntend, setHasShownExitIntend] = useState(false);
  const windowSize = useWindowResize();
  const elementRef = useRef() as MutableRefObject<HTMLDivElement>;
  const getIpAddress = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setPayload({ ipAddress: res.data.ip });
  };
  const [step2, setStep2] = useState<AccordionRoutesEnum>(AccordionRoutesEnum.ProductStep);
  const isDesktop = useStore.useIsDesktop();
  const setIsDesktop = useStore.useSetIsDesktop();
  const isDesktopEffectRanOnceRef = useRef(false);
  const salaryConfigUrlPriceRef = useRef<string | null>(null);
  const hasRunSalaryConfigTrackingRef = useRef(false);
  const setFromSalaryInsuranceConfig = useStore.useSetFromSalaryInsuranceConfigCard();
  //Basket
  const [showHelpForm, setShowHelpform] = useState<boolean>(false);
  const [chosenProducts, setChosenProducts] = useState<string>();

  //Used for contact form in basket
  useEffect(() => {
    let products = [""];
    payload.wantsUnemploymentBenefits && products.push("akasse");
    payload.wantsUnion && products.push("fagforening");
    payload.wantsSalaryInsurance && products.push("loensikring");
    payload.wantsSalaryInsuranceAndUnion && products.push("fagforeningloensikring");
    payload.wantsBasic && products.push("basis");
    payload.wantsHRJura && products.push("hrjura");
    setChosenProducts(products.join(", "));
  }, [payload.wantsUnemploymentBenefits, payload.wantsUnion, payload.wantsSalaryInsurance, payload.wantsSalaryInsuranceAndUnion, payload.wantsBasic, payload.wantsHRJura]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let translations: any;
        const settingsUrl = form?.dataset.jsonSettingsUrl;

        translations = await fetchTranslations(settingsUrl);

        setTranslations(translations.data);

        const unemploymentInsuranceOptions = await fetchUnemploymentInsuranceOptions();
        const unionOptions = await fetchUnionOptions();

        setUnemploymentInsuranceOptions(unemploymentInsuranceOptions.data);
        setUnionOptions(unionOptions.data);

        // If an occupation is passed in the query string, set it as the default value
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const occupation = urlParams.get("type");

        if (occupation === "employee") {
          setPayload({ occupation: "Employee" });
        }
        if (occupation === "selfemployed") {
          setPayload({ occupation: "SelfEmployed" });
        }
        if (occupation === "unemployed") {
          setPayload({ occupation: "Unemployed" });
        }
        if (occupation === "student") {
          setPayload({ occupation: "Student" });
        }

        getIpAddress();
      } catch (err) {}
    };

    const form = document.querySelector(`[data-component='form-enrollment-new']`) as HTMLElement;

    fetchData();

    const source = form?.dataset.source ?? "";
    const affiliate = form?.dataset.affiliate;
    const enableDiscounts = form?.dataset.enableDiscounts == "True" ? true : false;
    const nodeKey = form?.dataset.settingsNodeKey;
    const enableDiscountCodes = form?.dataset.enableDiscountcodes == "True" ? true : false;

    setOfferEnabled(enableDiscounts);
    setDiscountCodesEnabled(enableDiscountCodes);
    setPayload({ settingsNodeKey: nodeKey, source: source, affiliate: affiliate, payloadType: PayloadTypeEnum.FormEnrollmentNew.toString() });
    setSource(source);
  }, []);

  //Getting img from Umbraco backend
  useEffect(() => {
    const form = document.querySelector(`[data-component='form-enrollment-new']`) as HTMLElement;
    const imageUrl = form?.dataset.imageCampaignUrl;
    const mobileImageUrl = form?.dataset.imageMobileCampaignUrl;
    setCampaignImgUrl(`${imageUrl}`);
    setCampaignMobileImgUrl(`${mobileImageUrl}`);
  }, []);

  const currentWidth = useMemo(() => {
    return elementRef.current?.getBoundingClientRect().width;
  }, [windowSize]);

  const showGiftCardPopup = useMemo(() => {
    return switchLayout != VisibleLayoutEnum.ThankYou && switchLayout != VisibleLayoutEnum.CallMeReciept && accordionRoute != AccordionRoutesEnum.ContactMeStep;
  }, [accordionRoute, VisibleLayoutEnum]);

  //Check for window size
  useEffect(() => {
    if (window.innerWidth > 750) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }, []);

  const handleResize = () => {
    if (window.innerWidth > 750) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  };
  window.addEventListener("resize", handleResize);

  //Test of new OI
  //Check if occupation needs to be skipped
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const step = urlParams.get("step");
    const campaign = urlParams.get("campaign");
    const occupation = urlParams.get("type");
    const products = urlParams.get("produkt");

    if (occupation === "unemployed" && (products?.includes("fagforeningloensikring") || products?.includes("loensikring"))) {
      setCompletedAccordionRoute(AccordionRoutesEnum.OccupationStep);
      if (window.innerWidth > 750) {
        setStep2(AccordionRoutesEnum.ProductStepV2);
        setAccordionRoute(AccordionRoutesEnum.ProductStepV2, payload, step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
      } else {
        setStep2(AccordionRoutesEnum.ProductStep);
        setAccordionRoute(AccordionRoutesEnum.ProductStep, payload, step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
      }
    } else {
      //If step 2, skip occupation step
      if (step === "20") {
        setCompletedAccordionRoute(AccordionRoutesEnum.OccupationStep);
        Analytics.getInstance().trackStep(AccordionRoutesEnum.OccupationStep.toString(), step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical, payload);
        setAccordionRoute(step2 ? AccordionRoutesEnum.ProductStepV2 : AccordionRoutesEnum.ProductStep, payload, step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
      }
      //If step 3, skip occupation step and productstep
      if (step === "3") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const salaryinsuranceConfig = urlParams.get("salaryinsurance");
        const period = urlParams.get("period");
        const coverageAmount = urlParams.get("coverage");
        const grossSalary = urlParams.get("grossSalary");
        const urlPrice = urlParams.get("salaryinsurance");
     
        //If user comes from salary insurance configuration
        if (salaryinsuranceConfig) {
          setCompletedAccordionRoute(AccordionRoutesEnum.OccupationStep);
          setPayload({salaryInsurancePaymentPeriod: period?.toString(), salaryInsuranceBenefitAmount: coverageAmount?.toString(), monthlySalary: grossSalary?.toString()})
          //For tracking when coming from salary insurance configuration
          salaryConfigUrlPriceRef.current = urlPrice;

        } else {
          setCompletedAccordionRoute(AccordionRoutesEnum.OccupationStep);
          Analytics.getInstance().trackStep(AccordionRoutesEnum.OccupationStep.toString(), step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical, payload);
          if (window.innerWidth > 750) {
            setStep2(AccordionRoutesEnum.ProductStepV2);
            setCompletedAccordionRoute(AccordionRoutesEnum.ProductStepV2);
            Analytics.getInstance().trackStep(AccordionRoutesEnum.ProductStepV2.toString(), step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical, payload);
            Analytics.getInstance().trackProducts(payload, payload.combinationDiscount ? true : false, translations, step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
          } else {
            setStep2(AccordionRoutesEnum.ProductStep);
            setCompletedAccordionRoute(AccordionRoutesEnum.ProductStep);
            Analytics.getInstance().trackStep(AccordionRoutesEnum.ProductStep.toString(), step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical, payload);
            Analytics.getInstance().trackProducts(payload, payload.combinationDiscount ? true : false, translations, step2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
          }
          setAccordionRoute(AccordionRoutesEnum.CircumstanceStep, payload, step2 === AccordionRoutesEnum.ProductStepV2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
        }
    
      }
    }

    if (campaign !== null) {
      setSource(source);
      setPayload({ source: campaign });
    }
  }, []);

  //tracking skipped step when coming from salary insurance configuration - called once translations and payload are ready so the references for these work in analytics file
  const runSalaryConfigTracking = (urlPrice: string | null) => {
    //Tracking of questions showed on circumstanceStep
    const questions = [];
    questions.push("Arbejder du primært i DK");

    if (payload.wantsUnemploymentBenefits) {
      questions.push("Er du medlem af en akasse");
    }

    if (payload.wantsUnion) {
      questions.push("Er du medlem af en fagforening i dag");
    }

    if (payload.wantsSalaryInsuranceAndUnion) {
      questions.push("Er du medlem af en fagforening i dag");
      questions.push("Er du medlem af en akasse");
    }

    if (payload.wantsHRJura || payload.wantsBasic) {
      questions.push("Er du selvstændig på fuldtid");
    }
    // End of tracking questions for circumstance step

    if (window.innerWidth > 750) {
      setStep2(AccordionRoutesEnum.ProductStepV2);
      setCompletedAccordionRoute(AccordionRoutesEnum.ProductStepV2);
      Analytics.getInstance().trackProducts(payload, payload.combinationDiscount ? true : false, translations, TrackingFlowTypeEnum.SalaryConfig, Number(urlPrice));
      setAccordionRoute(AccordionRoutesEnum.CircumstanceStep, payload, TrackingFlowTypeEnum.SalaryConfig);
      // Tracking of circumstance step questions for desktop
      Analytics.getInstance().trackCircumstanceStep(questions, "circumstance_questions_start");
    } else {
      setStep2(AccordionRoutesEnum.ProductStep);
      setCompletedAccordionRoute(AccordionRoutesEnum.ProductStep);
      Analytics.getInstance().trackProducts(payload, payload.combinationDiscount ? true : false, translations, TrackingFlowTypeEnum.SalaryConfig, Number(urlPrice));
      setAccordionRoute(AccordionRoutesEnum.CircumstanceStep, payload, TrackingFlowTypeEnum.SalaryConfig);
      // Tracking of circumstance step questions for mobile
      Analytics.getInstance().trackCircumstanceStep(questions, "circumstance_questions_start");
    }
  };

  //Tracking for salary insurance configuration
  useEffect(() => {
    if (salaryConfigUrlPriceRef.current === null || hasRunSalaryConfigTrackingRef.current) return;
    if (!translations || !payload.occupation) return;

    hasRunSalaryConfigTrackingRef.current = true;
    setFromSalaryInsuranceConfig(true);
    runSalaryConfigTracking(salaryConfigUrlPriceRef.current);
  }, [translations, payload]);


  //Open and closes timer popup
  const showTimerPopup = () => {
    if (showTimer) {
      setShowTimer(false);
    } else {
      setShowTimer(true);
      setShowExitIntent(false);
    }
  };

  //Open and closes exit intent popup
  const showExitIntentPopup = () => {
    if (showExitIntent) {
      setShowExitIntent(false);
    } else {
      setShowExitIntent(true);
      setShowTimer(false);
    }
  };

  //Different productcards on mobile and desktop
  useEffect(() => {

    if (isDesktop) {
      setStep2(AccordionRoutesEnum.ProductStepV2);
    } else {
      setStep2(AccordionRoutesEnum.ProductStep);
    }
  }, [isDesktop]);

  return (
    <>
      {showGiftCardPopup === true && (
        <GiftcardWrapper>
          <GiftcardWidth>
            <GiftCardPopup isFront={true} source={source!} verticalOI={true} />
          </GiftcardWidth>
        </GiftcardWrapper>
      )}
      {switchLayout === VisibleLayoutEnum.Accordion && campaignImgUrl && (
        <CampaignImgDiv>
          <CampaignImgBg>
            {currentWidth < 768 && campaignMobileImgUrl && <CampaignImg src={campaignMobileImgUrl} alt="kampagne banner" />}
            {(currentWidth >= 768 || (currentWidth < 768 && !campaignMobileImgUrl)) && <CampaignImg src={campaignImgUrl} alt="kampagne banner" />}
          </CampaignImgBg>
        </CampaignImgDiv>
      )}
      {switchLayout === VisibleLayoutEnum.Accordion && (
        <>
          <Background marginTop={campaignImgUrl ? true : false} ref={elementRef} isDesktop={isDesktop}>
            <Wrapper isDesktop={isDesktop}>
              <WrapperWhenBanner show={campaignImgUrl ? true : false}>
                <OccupationStep step2={step2} />
                {step2 === AccordionRoutesEnum.ProductStep && <ProductStep />}
                {step2 === AccordionRoutesEnum.ProductStepV2 && <ProductStepV2 />}
                <CircumstanceStep step2={step2} />
                <InformationStep step2={step2} />
                <YourConsentStep step2={step2} />
                <PaymentStep step2={step2} />
              </WrapperWhenBanner>
            </Wrapper>
            {isDesktop && <Basket marginTop={campaignImgUrl ? true : false} openHelpForm={() => setShowHelpform(true)} />}
          </Background>
          {/* {showTimerPopupOI &&
      <ExitIntentPopup step={accordionRoute} showExitIntent={showTimer} onClose={() => {trackClose(); showTimerPopup();}}/>
    }
    {showExitIntentPopupOI &&
      <ExitIntentPopup step={accordionRoute} showExitIntent={showExitIntent} onClose={() => {trackClose(); showExitIntentPopup();}}/>
    } */}
        </>
      )}
      {switchLayout === VisibleLayoutEnum.ThankYou && <ThankYouStep />}
      {switchLayout === VisibleLayoutEnum.CallMeReciept && <ContactMeReciept />}
      {showHelpForm && <HelpForm onClose={() => setShowHelpform(false)} chosenProducts={chosenProducts} />}
    </>
  );
}
